(() => {
  'use strict';
  const tabs = [...document.querySelectorAll('.color-tab')];
  const details = [...document.querySelectorAll('.mycolor-product__detail')];
  function selectColor(index) {
    tabs.forEach((tab, i) => tab.setAttribute('aria-pressed', String(i === index)));
    details.forEach((detail, i) => detail.classList.toggle('is-active', i === index));
  }
  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => selectColor(i));
    tab.addEventListener('keydown', event => {
      const target = event.key === 'ArrowRight' ? (i + 1) % 5 : event.key === 'ArrowLeft' ? (i + 4) % 5 : event.key === 'Home' ? 0 : event.key === 'End' ? 4 : null;
      if (target !== null) { event.preventDefault(); selectColor(target); tabs[target].focus(); }
    });
  });
  document.querySelectorAll('[data-color-index]').forEach(link => link.addEventListener('click', () => selectColor(Number(link.dataset.colorIndex))));
  details.forEach(detail => {
    const quantity = detail.querySelector('input[name="quantity"]');
    const minus = detail.querySelector('.quantity-minus');
    const plus = detail.querySelector('.quantity-plus');
    if (!quantity || !minus || !plus) return;
    function normalizeQuantity() {
      const value = Number(quantity.value);
      quantity.value = String(Number.isFinite(value) ? Math.max(1, Math.min(99, Math.trunc(value))) : 1);
      minus.disabled = Number(quantity.value) <= 1;
      plus.disabled = Number(quantity.value) >= 99;
    }
    minus.addEventListener('click', () => { quantity.value = Number(quantity.value) - 1; normalizeQuantity(); });
    plus.addEventListener('click', () => { quantity.value = Number(quantity.value) + 1; normalizeQuantity(); });
    quantity.addEventListener('change', normalizeQuantity);
    normalizeQuantity();
  });

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const targets = [...document.querySelectorAll('[data-parallax]')];
  let frame = 0;
  function paintParallax() {
    frame = 0;
    targets.forEach(target => {
      const box = target.parentElement.getBoundingClientRect();
      const max = Number(target.dataset.maxShift || 18);
      const shift = motion.matches ? 0 : Math.max(-max, Math.min(max, (innerHeight / 2 - (box.top + box.height / 2)) * Number(target.dataset.parallax)));
      target.style.setProperty('--parallax-y', shift.toFixed(2) + 'px');
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(paintParallax); }
  addEventListener('scroll', schedule, {passive: true});
  addEventListener('resize', schedule, {passive: true});
  motion.addEventListener('change', schedule);
  schedule();

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('is-active');
    });
  });
  document.querySelectorAll('.js-parallax').forEach(target => observer.observe(target));
})();
